<template>
<div class="flex flex-row mt-4">
  <div class="h-12">
        <input
          type="month"
          class="month-report-top rounded-[8px] py-4 mr-5 h-12"
          v-model="dateFrom"
        />
  </div>
  <div
        class="bg-white flex justify-between w-[400px] pr-4  relative rounded-[8px] items-center h-12"
      >
        <div class="flex relative group p-1 px-4 v-bbgray min-w-[200px] w-full">
          <div v-if="choosenManager.name" class="flex justify-between">
            <div class="flex items-center cursor-pointer group">
              <div
                class="min-w-[1.5rem] w-11 h-11 rounded-full mr-4 text-clip overflow-hidden bg-green-500"
              >
                <span class="w-6 h-6">
                  <IcoPic
                    :pic="choosenManager?.picture"
                    :name="choosenManager?.name"
                  />
                </span>
              </div>
              <div class="flex flex-col justify-center text-clip overflow-hidden pr-8">
                <span
                  class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                  >Менеджер</span
                >
                <span
                  class="font-latobold text-base group-hover:text-green-500 transition-colors duration-300"
                  >{{ choosenManager?.name }}
                  {{ choosenManager?.secondname }}</span
                >
              </div>
            </div>
            <div
              class="absolute top-1/2 -translate-y-1/2 right-4 opacity-0 group-hover:opacity-100 transition-all duration-150"
            >
              <a class="group cursor-pointer" @click="choosenManager = {}">
                <svg
                  class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                >
                  <use xlink:href="@/assets/i.svg#ico-no"></use>
                </svg>
              </a>
            </div>
          </div>
  
          <template v-else>
            <div class="flex items-center w-full">
              <p
                class="text-gray-400 leading-none w-full min-w-[100px] max-w-[100px] mr-6"
              >
                Менеджер
              </p>
              <div class="relative min-w-[250px]">
                <input
                  type="text"
                  v-model.trim="text_manager"
                  class="bg-white h-9 px-3 py-1 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                  @input="findManager()"
                  @click="findManager()"
                />
                <hr />
                <div
                  v-if="managerList.length"
                  class="absolute w-full top-full bg-white left-0 bor align-middleder-2 border-green-800 border-t-0 z-20"
                >
                  <div
                    v-for="m in managerList"
                    :key="m"
                    @click="setManager(m)"
                    class="px-4 py-1 flex justify-between hover:text-green-500 cursor-pointer hover:shadow-md transition-all duration-300"
                  >
                    <span>{{ m.secondname }} {{ m.name }}</span>
                    <span class="text-xs">{{ m.uid }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
  <button v-if="choosenManager.name" @click="getReanimationListBtn" class="button-form-report rounded-[8px] h-12 ml-4">
            Показать
  </button>
</div>
<div
    class="mb-12 mt-4 grid grid-cols-order__top place-content-center gap-x-14px gap-y-24px"
    v-if="showData"
  >
    <div
      class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
      @click="Switch('all')"
    >
      <div
        class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
      >
        <svg
          class="z-1 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
        >
          <use xlink:href="@/assets/i.svg#status-1"></use>
        </svg>
        <h2
          class="text-2xl z-1 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
        >
          {{ reanimationWorkClients.length ?? "нет" }}
        </h2>
        <svg
          class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-[#42B6F8] group-hover:w-full group-hover:h-full transition-all duration-300"
        >
          <use xlink:href="@/assets/i.svg#bg-romb"></use>
        </svg>
      </div>
      <span
        class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-8 opacity-100 text-status-1 font-latobold"
      >
        Все
      </span>
    </div>
    <div
      class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
      @click="Switch('work')"
    >
      <div
        class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
      >
        <svg
          class="z-1 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
        >
          <use xlink:href="@/assets/i.svg#nav-masters"></use>
        </svg>
        <h2
          class="text-2xl z-1 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
        >
          {{ reanimationPlanWorkCount ?? "нет" }}
        </h2>
        <svg
          class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-[#FEAB1A] group-hover:w-full group-hover:h-full transition-all duration-300"
        >
          <use xlink:href="@/assets/i.svg#bg-romb"></use>
        </svg>
      </div>
      <span
        class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-8 opacity-100 text-[#FEAB1A] font-latobold"
      >
        В работе
      </span>
    </div>
    <div
      class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
      @click="Switch('back')"
    >
      <div
        class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
      >
        <svg
          class="z-1 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
        >
          <use xlink:href="@/assets/i.svg#status-8"></use>
        </svg>
        <h2
          class="text-2xl z-1 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
        >
          {{ reanimationPlanBackCount ?? "нет" }}
        </h2>
        <svg
          class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-[#3CC4AB] group-hover:w-full group-hover:h-full transition-all duration-300"
        >
          <use xlink:href="@/assets/i.svg#bg-romb"></use>
        </svg>
      </div>
      <span
        class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-8 opacity-100 text-[#3CC4AB] font-latobold"
      >
        Вернулся
      </span>
    </div>
    <div
      class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
      @click="Switch('refusal')"
    >
      <div
        class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
      >
        <svg
          class="z-1 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
        >
          <use xlink:href="@/assets/i.svg#ico-no"></use>
        </svg>
        <h2
          class="text-2xl z-1 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
        >
          {{ reanimationPlanRefusedCount ?? "нет" }}
        </h2>
        <svg
          class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-[#F4487E] group-hover:w-full group-hover:h-full transition-all duration-300"
        >
          <use xlink:href="@/assets/i.svg#bg-romb"></use>
        </svg>
      </div>
      <span
        class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-8 opacity-100 text-[#F4487E] font-latobold"
      >
        Отказ
      </span>
    </div>
 </div>
<div v-if="showData" class="flex flex-row justify-between mb-4">
    <div class="w-full min-w-full max-w-full max-h-[68vh] flex flex-row mt-2 gap-0 flex-wrap overflow-y-auto overflow-x-visible relative ">
      <div v-if="showData" class="bg-white h-14 mt-4 flex flex-row justify-around items-center gap-3 sticky top-0 z-10">
        <p class=" w-[30vw] max-w-[400px] uppercase text-center">Клиенты для отработки <br/> ({{ this.reanimationClientsCount }})</p>
        <p class=" w-[15vw] max-w-[220px] uppercase text-center">Задачи по реанимации <br/> ({{ this.tasksCount }})</p>
        <p class=" w-[27vw] max-w-[350px] uppercase text-center">Касания по реанимации <br/> ({{ this.touchesCount }})</p>
        <p class=" w-[27vw] max-w-[350px] uppercase text-center">ЛИДы по реанимации <br/> ({{ this.leadsCount }})</p>
        <p class=" w-[15vw] max-w-[220px] uppercase text-center">Счета по реанимации <br/> ({{ this.invoiceCount }})</p>

      </div> 
      <div v-for="(item, index) in shownReanimationWorkClients" :key="item.id" class=" h-auto flex flex-row gap-3 items-stretch ">
        <!-- карточка клиента -->
        <div @click="goToClient(item)" class="cursor-pointer w-[30vw] max-w-[400px] mt-2 flex flex-row justify-start items-center p-2"
        :class="index % 2 === 0 ? 'bg-[#F7FCFB]' : 'bg-white'">
          <div class="cell w5 self-center mr-2">
          #{{ item.client_iid }}
        </div>
        <div class="flex flex-row justify-between w-[100%]">
        <div class="ml-1 flex w-full">
            <div
              v-if="item.client_correct != 1"
              class="text-white w-11 h-11 mr-4 text-xl leading-none rounded-full self-center flex items-center justify-center min-w-[44px] bg-status-8"
            >
              <svg class="h-5 w-5 fill-white">
                <use xlink:href="@/assets/i.svg#status-11"></use>
              </svg>
            </div>
            <template v-else>
              <div
                class="text-white w-11 h-11 mr-4 text-xl leading-none rounded-full self-center items-center justify-center min-w-[44px] bg-status-6"
              >
                <IcoPic :pic="item.client_picture" :name="item.client_full" />
              </div>
            </template>
            <div
              class="font-latobold self-center text-center align-middle max-w-[180px] ml-auto mr-auto"
              >{{ item.client_full }}</div
            >
        </div>
        <div
          class="text-white self-center w-11 h-11 text-xl leading-none rounded-full flex items-center justify-center min-w-[44px]"
          :class="{
            'bg-status-5': item.client_activity === 'active' && !item.del,
            'bg-status-7': item.client_activity === 'passive' && !item.del,
            'bg-status-10': item.client_activity === 'back' && !item.del,
            'bg-status-19': item.client_activity === 'dead' && !item.del,
            'bg-status-12':
              (!item.client_activity && !item.del) || item.client_activity === 'nopay',
            'bg-status-13': item.client_activity === 'new' && !item.del,
            'bg-status-20': item.del,
          }"
        ></div>
      </div>
        </div>

        <!-- карточка задач -->
        <div v-if="item.task" @click="goToTask(item.task.id)" class="cursor-pointer w-[15vw] max-w-[220px] mt-2 flex flex-row justify-between p-2"
        :class="index % 2 === 0 ? 'bg-[#F7FCFB]' : 'bg-white'">
          <div class="cell w5 self-center flex flex-row gap-1 ">
            <svg
              class="min-w-5 min-h-5 w-5 h-5 mr-1 fill-status-20"
              v-if="item.task.status == 1"
            >
              <use xlink:href="@/assets/i.svg#ico-edit"></use>
            </svg>
            <svg
              class="min-w-5 min-h-5 w-5 h-5 mr-1 fill-status-1"
              v-if="item.task.status == 2"
            >
              <use xlink:href="@/assets/i.svg#status-1"></use>
            </svg>
            <svg
              class="min-w-5 min-h-5 w-5 h-5 mr-1 fill-status-3"
              v-if="item.task.status == 4"
            >
              <use xlink:href="@/assets/i.svg#status-3"></use>
            </svg>
            <svg
              class="min-w-5 min-h-5 w-5 h-5 mr-1 fill-status-5"
              v-if="item.task.status == 5"
            >
              <use xlink:href="@/assets/i.svg#status-5"></use>
            </svg>
            <svg
              class="min-w-5 min-h-5 w-5 h-5 mr-1 fill-status-6"
              v-if="item.task.status == 6"
            >
              <use xlink:href="@/assets/i.svg#status-8"></use>
            </svg>
            <svg
              class="min-w-5 min-h-5 w-5 h-5 mr-1 fill-status-11"
              v-if="item.task.status == 7"
            >
              <use xlink:href="@/assets/i.svg#ico-no"></use>
            </svg>
            <svg
              class="min-w-5 min-h-5 w-5 h-5 mr-1 fill-status-11"
              v-if="item.task.status == 19"
            >
              <use xlink:href="@/assets/i.svg#status-11"></use>
            </svg>
              <svg v-if="item.task.violate" class="w-5 h-5 fill-status-11">
                <use xlink:href="@/assets/i.svg#status-11"></use>
              </svg>
        </div>
        <div class="cell w5 self-center ">
          #{{ item.task.iid }}
        </div>
        <div class="cell w5 self-center flex flex-col">
          <p>{{ new Date(item.task.date).toLocaleDateString('RU-ru') }}</p>
          <p>{{ new Date(item.task.date).toLocaleTimeString('RU-ru') }}</p>

        </div>
        </div>
        <div v-else class="w-[15vw] max-w-[220px] mt-2 flex flex-row  bg-none">
        </div>

                <!-- карточка касаний -->
        <div v-if="item.touch" @click="goToTouch(item.touch.id)" class="cursor-pointer w-[27vw] max-w-[350px] mt-2 flex flex-row justify-start items-center p-2"
        :class="index % 2 === 0 ? 'bg-[#F7FCFB]' : 'bg-white'">
            <div class="w-5 h-5 mr-2">
              <svg
                v-if="item.touch.status == 1"
                class="w-full h-full"
                :class="'fill-status-' + item.touch.status"
              >
                <use xlink:href="@/assets/i.svg#status-1"></use>
              </svg>
              <svg
                v-if="item.touch.status == 2"
                class="w-full h-full"
                :class="'fill-status-6'"
              >
                <use xlink:href="@/assets/i.svg#status-6"></use>
              </svg>
              <svg
                v-if="item.touch.status == 3"
                class="w-full h-full"
                :class="'fill-status-11'"
              >
                <use xlink:href="@/assets/i.svg#ico-no"></use>
              </svg>
            </div>
            <div class="flex flex-col">
              <div>
                #{{ item.touch.id }}
              </div>
          

        
          <div class="flex items-center mr-2">
            <svg class="fill-gray-400 w-2 h-2 mr-1 rotate-45">
              <use xlink:href="@/assets/i.svg#ico-no"></use>
            </svg>
            <div class="text-gray-400 text-xs">
              {{ new Date (item.touch.created_at).toLocaleDateString('Ru-ru') }}
            </div>
          </div>
        </div>
          <span
            class="text-white w-11 h-11 text-xl leading-none rounded-full flex items-center justify-center min-w-[44px] mr-2"
            :class="{
              'bg-status-1': item.touch.status == 1,
              'bg-status-6': item.touch.status == 2,
              'bg-status-9': item.touch.status == 3,
              'bg-status-grey': item.touch.del == 1,
            }"
          >
            {{ item.client_full?.slice(0, 1) }}
          </span>
          <div
            class="justify-center overflow-hidden max-w-[140px]"
          >
            <span
              class="text-center align-middle self-center font-semibold break-all max-h-10 leading-5"
              >{{ item.client_full}}</span
            >
          </div>
        
        </div>
      <div v-else class="w-[27vw] max-w-[350px] mt-2 flex flex-row bg-none">
      </div>

      <!-- карточка ЛИДОВ -->
      <div v-if="item.lead" @click="goToLead(item.lead.id)" class="cursor-pointer w-[27vw] max-w-[350px] mt-2 flex flex-row justify-around items-center p-2"
      :class="index % 2 === 0 ? 'bg-[#F7FCFB]' : 'bg-white'">
      <div>
        <svg
              v-if="item.lead.status == 1"
              class="w-5 h-5 mr-1"
              :class="'fill-status-' + item.lead.status"
            >
              <use xlink:href="@/assets/i.svg#status-1"></use>
            </svg>
            <svg
              v-if="item.lead.status == 2"
              class="w-5 h-5 mr-1"
              :class="'fill-status-2'"
            >
              <use xlink:href="@/assets/i.svg#nav-masters"></use>
            </svg>
            <svg
              v-if="item.lead.status == 6"
              class="w-5 h-5 mr-1"
              :class="'fill-status-6'"
            >
              <use xlink:href="@/assets/i.svg#status-6"></use>
            </svg>
            <svg
              v-if="item.lead.status == 11"
              class="w-5 h-5 mr-1"
              :class="'fill-status-11'"
            >
              <use xlink:href="@/assets/i.svg#ico-no"></use>
            </svg>
            <svg
              v-if="item.lead.status == 8"
              class="w-5 h-5 mr-1"
              :class="'fill-status-11'"
            >
              <use xlink:href="@/assets/i.svg#status-11"></use>
            </svg>
          </div>
          <div>
            <svg v-if="item.lead.violate" class="w-5 h-5 fill-status-11 mr-1">
              <use xlink:href="@/assets/i.svg#status-11"></use>
            </svg>
          </div>
          <div class="flex flex-col">
          <div>
          #{{ item.lead.iid }}
          </div>

        <div class="items-center">
          <div class="flex items-center mr-2">
            <svg class="fill-gray-400 w-2 h-2 mr-1 rotate-45">
              <use xlink:href="@/assets/i.svg#ico-no"></use>
            </svg>
            <div class="text-gray-400 text-xs">
              {{ new Date (item.lead.create_at).toLocaleDateString("Ru-ru") }}
            </div>
          </div>
        </div>
      </div>
        <div
          class="flex w-full h-full items-center col-span-3 justify-start"
        >
          <span
            class="text-white w-11 h-11 text-xl leading-none rounded-full flex items-center justify-center mr-2"
            :class="'bg-status-' + item.lead.status"
          >
            {{ item.client_full?.slice(0, 1) }}
          </span>
          <div class="flex flex-col justify-center overflow-hidden mr-3">
            <span
              class="text-center align-middle self-center font-semibold break-all max-h-10 leading-5 max-w-[130px]"
              >{{ item.client_full }}</span
            >
          </div>
        </div>
        </div>
      <div v-else class="w-[27vw] max-w-[350px] mt-2 flex flex-row bg-none">
      </div>

      <!-- карточка Счета -->
      <div v-if="item.invoice_id" @click="goToInvoice(item.invoice_id)" class="cursor-pointer w-[15vw] max-w-[220px] mt-2 flex flex-row justify-between p-2"
        :class="index % 2 === 0 ? 'bg-[#F7FCFB]' : 'bg-white'">
        <div class="cell w5 self-center ">
          #{{ item.invoice_invoice_number}}
        </div>
        <div class="font-latobold self-center text-center align-middle max-w-[180px] ml-auto mr-auto">
            <span
            class="text-white w-11 h-11 text-xl leading-none rounded-full flex items-center justify-center min-w-[44px] mr-2"
            :class="{
              'bg-[#42B6F8]': item.invoice_status == 1,
              'bg-[#007ABF]': item.invoice_status == 2,
              'bg-[#1D8074]': item.invoice_status == 3,
              'bg-[#F4487E]': item.invoice_status == 4,
             }">
              {{ item.client_full?.slice(0, 1) }}
            </span>
        </div>
        <div class="font-latobold self-center text-center align-middle max-w-[180px] ml-auto mr-auto"
              >{{ item.invoice_sum }}р.
        </div>
        </div>
        <div v-else class="w-[15vw] max-w-[220px] mt-2 flex flex-row  bg-none">
        </div>
      </div>
    </div>
    </div>
    <div
        v-if="s.popup == 'task'"
        id="popnew"
        class="w-3/4 bg-white fixed left-1/2 -translate-x-1/2 z-20 rounded-lg top-4 bottom-4 max-h-max overflow-hidden max-l:w-11/12 max-l:max-w-11/12"
      >
        <TaskEdit @close="close" />
      </div>

      <div
        v-if="s.popup"
        @click="close"
        id="overlay"
        class="fixed bg-cyan-900 z-2 w-screen h-screen top-0 left-0 opacity-80"
      ></div>
      <!-- <div v-if="isModalOpen" class="fixed inset-0 z-50 flex items-center justify-center">
      Затемненный фон
      <div @click="closeModal" class="absolute inset-0 bg-black bg-opacity-50"></div>
      
      Контент модалки
      <div class="relative bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h3 class="text-lg font-medium mb-4">Добавить комментарий</h3>
        
        Поле ввода
        <textarea 
          v-model="commentText"
          class="w-full p-3 border border-gray-300 rounded mb-4 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Введите ваш комментарий..."
          rows="4"
        ></textarea>
        
        Сообщение об ошибке
        <p v-if="error" class="text-red-500 mb-4">{{ error }}</p>
        
        Кнопки
        <div class="flex justify-end space-x-3">
          <button @click="closeModal" class="px-4 py-2 text-gray-700 hover:text-gray-900">
            Отмена
          </button>
          <button 
            @click="submitComment"
            class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
          >
            Отправить
          </button>
        </div>
      </div>
    </div> -->
</template>
  
  <script>
  import { toRaw } from "vue";
  import { mapActions, mapGetters } from "vuex";
  // import router from "@/router/router";
  // import { toRaw } from "vue";
  // import IcoPic from "../components/ui/IcoPic.vue";


  export default {
    name: "ReanimationPlan",
    components:{
    },
    data() {
      return {
        dateFrom: null,
        text_manager: "",
        choosenManager: {},
        managerList: [],
        showData: false,
        selectedClients: [],
        showTaskModal: false,
        isModalOpen: false,
        commentText: '',
        error: '',
        ropCommentedList:[],
        reanimationClientsCount: 0,
        touchesCount: 0,
        tasksCount: 0,
        leadsCount: 0,
        invoiceCount: 0
      };
    },
    computed: {
      ...mapGetters(["selectManagers", "s", "shownReanimationWorkClients", 'reanimationPlanWorkCount', 'reanimationPlanBackCount', 'reanimationPlanRefusedCount', 'reanimationWorkClients' ]),
    },
    methods: {
      ...mapActions(["clearSettings","goToInvoiceNowReanimation", "findManager", "getClientforReanimation", "goToTouchFromLeadReanimation", "goToLeadFromTouchReanimation", "showTask", "getReanimationList", 'showTouch', 'findReanimationPlan', "setSettings",
      ]),
      async getReanimationListBtn(){
        await this.getReanimationList({uid:this.choosenManager.uid, date:this.dateFrom})
        this.showData = true
        this.calcReanimationClientsCount()
        this.calcEndedTouchesCount()
    },
    findManager() {
        this.managerList = this.selectManagers.filter(
          (item) =>
            item.name.toLowerCase().indexOf(this.text_manager.toLowerCase()) !==
            -1
        );
      },
      setManager(manager) {
        this.choosenManager = manager;
      },
    selectClient(value){
      if(toRaw(this.selectedClients.includes(value))){
        this.selectedClients.splice(toRaw(this.selectedClients.indexOf(value)), 1)
      }
      else{this.selectedClients.push(value)}
    },
    // async sendClients(){
    //   let result = confirm("Вы уверены, что хотите добавить назначить этих клиентов данному менеджеру? Данное действие безвозвратное, оно влечёт за собой запуск задачи!")
    //   if(result){
    //     let formdata = new FormData
    //     formdata.append('manager_id', this.choosenManager.uid)
    //     formdata.append('client_ids', toRaw(this.selectedClients))
    //     API.POST('reanimation/add', formdata)
    //     this.selectedClients = []
    //     await this.getReanimationListBtn({uid:this.choosenManager.uid, date:this.dateFrom})
    //   }
    //   else{return}
    // },
    async goToClient(data){
        await this.getClientforReanimation(data)
        window.open("/client/view", '_blank')
      },
      goToTouch(lead) {
      this.goToTouchFromLeadReanimation(toRaw(lead));
    },

    goToInvoice(invoice) {
      this.goToInvoiceNowReanimation(invoice);
    },
    goToTask(task){
      this.showTask(toRaw({id: task}))
      this.showTaskModal = true
    },

    goToLead(lead) {
      this.goToLeadFromTouchReanimation(lead);
    },

    calcReanimationClientsCount(){
      this.reanimationClientsCount = 0
      this.reanimationClientsCount = this.shownReanimationWorkClients.length
    },

    calcEndedTouchesCount(){
      this.touchesCount = 0
      this.tasksCount = 0
      this.leadsCount = 0
      this.invoiceCount = 0
      for (let i = 0; i < this.shownReanimationWorkClients.length; i++){
        if(this.shownReanimationWorkClients[i].touch){
          this.touchesCount += 1
        }
        if(this.shownReanimationWorkClients[i].task){
          this.tasksCount += 1
        }
        if(this.shownReanimationWorkClients[i].lead){
          this.leadsCount += 1
        }
        if(this.shownReanimationWorkClients[i].invoice_id){
          this.invoiceCount += 1
        }
      }
    },
    Switch(value) {
      this.s.reanimationStatus = value;
      this.setSettings(this.s)
      this.findReanimationPlan(this.s);
      this.calcEndedTouchesCount()
      this.calcReanimationClientsCount()
    },
    // ropAccept(id){
    //   const result = 1
    //   this.openModal()
    //   this.submitComment(result , id)
    // },
    // ropDesline(id){
    //   const result = 2
    //   this.openModal()
    //   this.submitComment(result , id)

    // },
    // openModal() {
    //   this.isModalOpen = true
    //   this.commentText = ''
    //   this.error = ''
    // },
    // closeModal() {
    //   this.isModalOpen = false
    // },
    // submitComment() {
    //   // Проверка на пустоту
    //   if (!this.commentText.trim()) {
    //     this.error = 'Комментарий не может быть пустым'
    //     return
    //   }
      
    //   // Здесь логика отправки комментария
      
    //   // Закрываем модалку после отправки
    //   this.closeModal()
      
    //   // Можно вызвать метод API или emit событие
    //   // this.$emit('comment-submitted', this.commentText)
    // }
},
mounted() {
      this.clearSettings()
      var currentYear = new Date().getFullYear();
      var lastMonth = new Date().getMonth();
      var currentMonth = lastMonth + 1;

      if (currentMonth < 10) {
        this.dateFrom = "" + currentYear + "-0" + currentMonth;
      } else {
        this.dateFrom = "" + currentYear + "-" + currentMonth;
      }
    }
}
  </script>
  
  <style scoped>
    .month-report-top {
    padding: 12px 15px;
    border-radius: 4px;
    }
    .button-form-report {
      border-radius: 8px;
      background: #22c55e;
      border: none;
      color: #fff;
      text-align: center;
      font-size: 13.5px;
      font-weight: 700;
      line-height: 13.5px;
      text-transform: uppercase;
      padding: 15px 88px;
    }
        /* Анимация появления модалки */
    .fade-enter-active, .fade-leave-active {
      transition: opacity 0.3s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
  </style>
  